import { useMutation, useQueryClient } from 'react-query'
import { STANDING_CONSENT_ACCEPTANCE_HINTS_KEY } from 'src/modules/event/hooks/use-standing-consent-acceptance-hints'
import { STANDING_CONSENT_ACTIVE_STATUS_KEY } from 'src/modules/user/hooks/use-standing-consent-active-status'
import { ApiService } from 'src/services/api.service'

export function useRevokeAllActiveStandingConsents() {
  const queryClient = useQueryClient()

  return useMutation(() => ApiService.PhoneStandingConsents.revokeAllActive(), {
    onSuccess: () => {
      queryClient.invalidateQueries([STANDING_CONSENT_ACTIVE_STATUS_KEY])
      queryClient.invalidateQueries(STANDING_CONSENT_ACCEPTANCE_HINTS_KEY)
    },
  })
}
